import { useEffect, useState } from "react";
import { getFromLocalStorage, saveToLocalStorage } from "utils/localStorage";

// This hook is used to manage the visibility of the week challenge modal
interface WeekChallengeModalLocalStorage {
  name: string;
  count: number;
}

export const useWeeklyChallengeModalLocalStorage = (challengeName: string) => {
  const [hasSeenModal, setHasSeenModal] = useState<number>(0);

  // Load the value from localStorage on the first render
  useEffect(() => {
    const hasSeenModalLS = getFromLocalStorage<WeekChallengeModalLocalStorage>("week-challenge-modal");

    if (!hasSeenModalLS) return;
    if (hasSeenModalLS?.name !== challengeName) {
      saveToLocalStorage("week-challenge-modal", { name: challengeName, count: 0 });
      setHasSeenModal(0);
      return;
    }

    setHasSeenModal(hasSeenModalLS.count);
  }, []);

  // This effect listens to changes in localStorage and updates the state accordingly
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "week-challenge-modal") {
        const newValue: WeekChallengeModalLocalStorage =
          event.newValue !== null ? JSON.parse(event.newValue) : { name: "", count: 0 };
        setHasSeenModal(newValue.count);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Save the new value to localStorage
  const setSeenModalToLocalStorage = () => {
    const newValue = hasSeenModal + 1;
    setHasSeenModal(newValue);
    saveToLocalStorage("week-challenge-modal", { name: challengeName, count: newValue });
  };

  return { isConfirmationModalAllowed: hasSeenModal < 3, setSeenModalToLocalStorage };
};
